export const objectToParams = (obj) => {
    let str = '';
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const prefix = str === '' ? '?' : '&';
            str += `${prefix}${key}=${encodeURIComponent(obj[key])}`;
        }
    }
    return str;
}

export const apiRoutes = {
    requestResetPassword: (username, recaptchaToken) => {
        const encodedUsername = encodeURIComponent(username);
        return `/auth/reset?username=${encodedUsername}&recaptchaToken=${recaptchaToken}`;
    },
    resetPassword: '/auth/reset',
    profile: '/profile',
    reports: (filter) => {
        return `/reports/?${objectToParams(filter)}`;
    },
    report: (slug, filter) => {
        return `/report/${slug}${objectToParams(filter)}`;
    },
    scenarios: '/scenarios',
    scenario: (slug) => {
        return `/scenario/${slug}`;
    },
    interactions: (scenarioId) => {
        return `/interactions/${scenarioId}`;
    },
    settings: {
        google: '/settings/google',
    },
    apiKeys: '/settings/apikeys',
    apiKey: (id) => {
        return `/settings/apikey/${id}`;
    },
    deleteApiKey: (id) => {
        return `/settings/apikey/${id}`;
    },
    users: '/users',
    user: (id) => `/users/${id}`,
    tenant: '/tenant',
    history: (params) => {
        return `/history${objectToParams(params)}`;
    },
    video: (requestId) => {
        return `/video/${requestId}`;
    },
}
